import type {
  MemberPaymentsFilterValue,
  MemberPaymentsSearchFilters,
  MemberPaymentsSearchParams
} from '@library/types/memberPayments';
import { useCallback, useState } from 'react';
import { PaymentsWithdrawalsFilters } from '@library/components/PaymentsWithdrawalsFilters';
import { PrizepicksDateRange } from '@library/components/datePicker';
import { ResetIconButton } from '@library/components/buttons';
import type { WithdrawalsFilters } from '@library/types/filters';

export interface MemberWithdrawalsFiltersProps {
  memberPaymentsSearchFilters: MemberPaymentsSearchFilters;
  onChangeWithdrawalsFilter: ({
    key,
    value
  }: MemberPaymentsSearchParams) => void;
  onResetWithdrawalsFilters: () => void;
}

export const MemberWithdrawalsFilters = ({
  memberPaymentsSearchFilters,
  onChangeWithdrawalsFilter,
  onResetWithdrawalsFilters
}: MemberWithdrawalsFiltersProps) => {
  const [endDatePickerOpen, setEndDatePickerOpen] = useState(false);
  const [startDatePickerOpen, setStartDatePickerOpen] = useState(false);

  const { dateRange, withdrawalMethod, withdrawalStatus } =
    memberPaymentsSearchFilters;

  const withdrawalsFilters: WithdrawalsFilters = {
    withdrawalMethod: withdrawalMethod ?? '',
    withdrawalStatus: withdrawalStatus ?? ''
  };

  const { fromDate, toDate } = dateRange;
  const formattedStartDate = fromDate?.toJSDate();
  const formattedEndDate = toDate?.toJSDate();

  const handleFilterChange = useCallback(
    (key: keyof MemberPaymentsSearchFilters) =>
      (value: MemberPaymentsFilterValue) => {
        onChangeWithdrawalsFilter({ key, value });
      },
    [onChangeWithdrawalsFilter]
  );

  return (
    <div className="flex flex-wrap items-center gap-4">
      <div className="shrink-0 basis-[25rem]">
        <PrizepicksDateRange
          disabled={false}
          endDate={formattedEndDate}
          endDatePlaceholder="End Date"
          endOpen={endDatePickerOpen}
          handleChange={handleFilterChange('dateRange')}
          minDate={undefined}
          startOpen={startDatePickerOpen}
          startDate={formattedStartDate}
          startDatePlaceholder="Start Date"
          setEndOpen={setEndDatePickerOpen}
          setStartOpen={setStartDatePickerOpen}
        />
      </div>
      <PaymentsWithdrawalsFilters
        className="h-11 w-full"
        containerClassName="h-11 w-44"
        filters={withdrawalsFilters}
        onWithdrawalStatusChange={handleFilterChange('withdrawalStatus')}
        onWithdrawalMethodChange={handleFilterChange('withdrawalMethod')}
        showOptionIcons
      />
      <ResetIconButton
        className="disabled:text-soClean-140 !m-0 shrink-0 basis-28 !p-0"
        disabled={false}
        label="Reset Filters"
        onClick={onResetWithdrawalsFilters}
      />
    </div>
  );
};
